import $http from '@/resource';
import utils from '@/utils';
import Cache from '@/cache';

const $api = {};

/**
 * 获取单位成员列表
 *
 * @param {object} searchData 搜索条件数组
 *
 * @date 2018-8-13 16:57:26
 *
 * @return {promise}
 */
$api.getGroupUserList = (searchData)=>{
    const url = "company/users" + '?page_size=' + searchData.page_size + "&page=" + searchData.page + "&type=" + searchData.type + "&key_word=" + searchData.key_word + "&company_group_id=" + searchData.company_group_id;
    const promise = new Promise(resolve => {
        $http.get(url).then(response=>{
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 禁止/解除禁止用户
 *
 * @param {object} data 需要用到的数据包括uid,islogin
 *
 * @date 2018-8-13 16:58:45
 *
 * @return {promise}
 */
$api.setUserStatus = (data) => {
    const url = "company-user/status";
    const promise = new Promise(resolve => {
        $http.patch(url,data).then(response=>{
            if (response.code === "200") {
                resolve(response);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 获取用户的基本信息
 *
 * @param {string} uid 用户uid
 *
 * @date 2018-8-14 15:20:54
 *
 * @return {promise}
 */
$api.getUserBaseInfo = (uid) => {
    const url = "userinfo/"+uid;
    const promise = new Promise(resolve => {
        $http.get(url).then(response => {
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 更换用户的所属部门
 *
 * @param {string} uid 用户uid
 * @param {string} groupId 部门id
 *
 * @date 2018-8-14 17:10:46
 *
 * @return {promise}
 */
$api.setUserGroup = (uid,groupId) => {
    const url = "company-user/"+uid+"/group/"+groupId;
    const promise = new Promise(resolve => {
        $http.patch(url).then(response=>{
            if (response.code === "200") {
                resolve(response);
            } else {
                utils.message({title: response.msg}, 'error');
            }
        });
    });
    return promise;
};

/**
 * 获取用户所具有的基础权限
 *
 * @param {string} uid 用户uid
 *
 * @date 2018-8-14 20:23:09
 *
 * @returns {Promise<any>}
 */
$api.getUserBaseAuth = (uid) => {
    const url = "company-user/"+uid+"/basic-permissions";
    const promise = new Promise(resolve => {
        $http.get(url).then(response=>{
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 设置用户的基本权限
 *
 * @param {string} uid 用户uid
 * @param {object} authData 用户权限数组
 *
 * @date 2018-8-14 20:24:22
 * @returns {Promise<any>}
 */
$api.setUserBaseAuth = (uid,authData) => {
    const url = "company-user/"+uid+"/basic-permissions";
    const promise = new Promise(resolve => {
        $http.put(url,authData).then(response=>{
            resolve(response);
        })
    });
    return promise;
};

/**
 * 设置用户基础信息
 *
 * @param {string} uid 用户uid
 * @param {object} data 待提交的数据
 *
 * @date 2018-8-15 20:48:39
 *
 * @returns {Promise<any>}
 */
$api.setUserBaseInfo = (uid,data) => {
    const url = "userinfo/"+uid;
    const promise = new Promise(resolve => {
        $http.put(url,data).then(response=>{
            if (response.code === "200") {
                resolve(response);
            } else {
                utils.message({title: response.msg}, 'error');
            }
        })
    });

    return promise;
};

/**
 * 离职|转移单位用户数据
 *
 * @param {object} data 待提交的数据
 *
 * @date 2018-8-16 19:24:49
 *
 * @returns {Promise<any>}
 */
$api.transferUserData = (data) => {
    const url = "user-data/transfer";
    const promise = new Promise(resolve => {
        $http.put(url,data).then(response=>{
            if (response.code === "200") {
                resolve(response);
            } else {
                utils.notice(response.msg, 'error');
            }
        })
    });
    return promise;
};

/**
 * 获取用户所具有的的所有继承权限
 *
 * @param {string} uid 用户uid
 *
 * @date 2018-8-16 19:30:52
 *
 * @returns {Promise<any>}
 */
$api.getUserInheritAuthList = (uid) =>  {
    const url = "company-user/"+uid+"/extends";
    const promise = new Promise(resolve => {
        $http.get(url).then(response=>{
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        })
    });
    return promise;
};

/**
 * 获取分组继承权限要用到的部门列表
 */
$api.getGroupAboutAuthList = ()=>{
    const url = "plugin/group-level";
    const promise = new Promise(resolve => {
        $http.get(url).then(response=>{
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        })
    });
    return promise;
};

/**
 * 设置用户的高级权限
 *
 * @param {object} data 待提交的数据
 *
 * @date 2018-8-18 11:46:58
 *
 * @returns {Promise<any>}
 */
$api.setGroupAboutAuthList = (data) => {
    const url = "company-user/allpermissions";
    const promise = new Promise(resolve => {
        $http.post(url,data).then(response=>{
            resolve(response);
        })
    });
    return promise;
};

/**
 * 批量添加单位成员
 *
 * @param {object} data 待添加的数据
 *
 * @date 2018-8-18 15:38:46
 *
 * @returns {Promise<any>}
 */
$api.addGroupMembers = (data) => {
    const url = "company/users";
    const promise = new Promise(resolve => {
        $http.post(url,data).then(response=>{
            resolve(response);
        })
    });
    return promise;
};

/**
 * 获取申请加入单位的成员列表
 *
 * @param {int} page 页码
 * @param {int} page_size 单页条数
 *
 * @date 2018-8-18 16:35:35
 *
 * @returns {Promise<any>}
 */
$api.getMemberJoinApplication = (page=1,page_size=10)=>{
    const url = "company/requset-users?page="+page+"&page_size="+page_size;
    const promise = new Promise(resolve => {
        $http.get(url).then(response=>{
            resolve(response);
        })
    });
    return promise;
};

/**
 * 批量审批用户加入单位的申请，通过|拒绝
 *
 * @param {object} data 待审批的数据
 *
 * @date 2018-8-20 09:01:25
 *
 * @returns {Promise<any>}
 */
$api.approveGroupApplication = (data)=>{
    const url = "company-users-checking";
    const promise = new Promise(resolve => {
        $http.post(url,data).then(response=>{
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        })
    });
    return promise;
};

/**
 * 获取用户加入单位申请的详情信息
 *
 * @param {string} id 申请id
 * @param {string} uid 用户uid
 *
 * @date 2018-8-20 10:55:47
 *
 * @returns {Promise<any>}
 */
$api.getMemberApplicationInfo = (id,uid)=>{
    const url = "company-user?msgId="+id+"&uid="+uid;
    const promise = new Promise(resolve => {
        $http.get(url).then(response=>{
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        })
    });
    return promise;
};

export default $api;


// WEBPACK FOOTER //
// ./src/service/company/member.js